import supportClientFactory from './apigClient'
import AWSClockSkewHandler from "../AWSClockSkewHandler"
import store from "@/store"

class SupportApi {
  constructor() {
    this.inited = false
    this.client = null
  }

  init() {
    if(!this.inited) {
      this.inited = true
      console.log(process.env.VUE_APP_SUPPORT_URL)
      this.client = supportClientFactory.newClient(store.state.credentials, process.env.VUE_APP_SUPPORT_URL)
    }
  }

  async callSupport(action, params = {}) {
    this.init()

    let error
    let result = await AWSClockSkewHandler.handleClockSkew(() => {
      return this.client.supportPost({
        deviceUUID: store.state.deviceUUID
      }, {
        action,
        ...params
      })
    }).catch(err => {
      error = err
    })

    if(error) throw error
    return result
  }

  async listTickets() {
    return this.callSupport('list_tickets')
  }

  async getTicket(altAccountId, createdAt) {
    return this.callSupport('get_ticket', { altAccountId, createdAt })
  }

  async getUploadUrl(createdAt, filename, contentType, size) {
    const params = { filename, contentType, size }
    if (createdAt) params.createdAt = createdAt
    return this.callSupport('get_upload_url', params)
  }

  uploadToPresignedUrl(url, file, contentType, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('PUT', url)
      xhr.setRequestHeader('Content-Type', contentType || file.type)
      if (onProgress) {
        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) onProgress(e.loaded / e.total)
        })
      }
      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) resolve()
        else reject(new Error(`Upload failed: ${xhr.status}`))
      })
      xhr.addEventListener('error', () => reject(new Error('Upload failed: network error')))
      xhr.send(file)
    })
  }

  async newTicket(message, attachments) {
    const params = { message }
    if (attachments && attachments.length > 0) params.attachments = attachments
    return this.callSupport('new_ticket', params)
  }

  async sendMessage(altAccountId, createdAt, message, attachments) {
    const params = { altAccountId, createdAt, message }
    if (attachments && attachments.length > 0) params.attachments = attachments
    return this.callSupport('send_message', params)
  }

  async requestHuman(altAccountId, createdAt) {
    return this.callSupport('request_human', { altAccountId, createdAt })
  }

  async requestAI(altAccountId, createdAt) {
    return this.callSupport('request_ai', { altAccountId, createdAt })
  }

  async closeTicket(altAccountId, createdAt, closeMessage) {
    return this.callSupport('close_ticket', { altAccountId, createdAt, closeMessage })
  }

  async reopenTicket(altAccountId, createdAt) {
    return this.callSupport('reopen_ticket', { altAccountId, createdAt })
  }
}

export default (new SupportApi())
